// extracted by mini-css-extract-plugin
export var personality = "personality-module--personality--aacad";
export var personality__col = "personality-module--personality__col--691e7";
export var personality__colFifth = "personality-module--personality__col--fifth--211c5";
export var personality__colFirst = "personality-module--personality__col--first--4c930";
export var personality__colFourth = "personality-module--personality__col--fourth--75db3";
export var personality__colImg = "personality-module--personality__col-img--39c07";
export var personality__colSecond = "personality-module--personality__col--second--9fcc0";
export var personality__colSixth = "personality-module--personality__col--sixth--c7495";
export var personality__colThird = "personality-module--personality__col--third--ba09d";
export var personality__link = "personality-module--personality__link--0f56b";
export var personality__row = "personality-module--personality__row--5f1ef";
export var personality__subtitle = "personality-module--personality__subtitle--e6870";
export var personality__text = "personality-module--personality__text--fd053";
export var personality__title = "personality-module--personality__title--c3736";